import { Table } from 'antd'
import React from 'react'

export default function UserPreviewTable({ data, blank }) { 
  return (
      <Table dataSource={data} rowKey={(r) => r.id}>
          <Table.Column title="Email" key="email" dataIndex="email" />
          <Table.Column title="Username" key="username" dataIndex={!blank ? "username" : ''} />
          <Table.Column title="First Name" key="first_name" dataIndex={!blank ? "first_name" : ''} />
          <Table.Column title="Last Name" key="last_name" dataIndex={!blank ? "last_name" : ''} />
          <Table.Column title="Title" key="title" dataIndex={!blank ? "title" : ''} />
          <Table.Column title="Status" key="status" dataIndex={!blank ? "status" : ''} />
          <Table.Column title="Role(s)" key="roles" dataIndex={!blank ? "roles" : ''} />
      </Table>
  )
}
